import { useQuery } from '@tanstack/react-query';

import { auctionsApi } from '../api/auctions-api';

import { auctionKeys } from './auction-keys';

/** The store product's variants with their store price, for picking the lot. */
export function useLotVariants(storeId: string, storeProductId: string | null) {
  return useQuery({
    queryKey: auctionKeys.lotVariants(storeId, storeProductId ?? ''),
    queryFn: () => auctionsApi.lotVariants(storeId, storeProductId ?? ''),
    enabled: storeProductId !== null,
  });
}
